<template lang="pug">
    .login-2fa
        .re-verification-form
            .re-verification-title Enter your code
            .re-verification-notice We have sent a code to your phone: {{ phone }}
            .re-verification-issue(v-if="error")
                .left-border
                .right-content
                    .re-verification-issue-title Invalid code
                    .re-verification-issue-description
                        span The Entered code is incorrect. Please, try again or click to
                        span.resend(@click="resend") Resend Code
            .re-verification-numbers
                input.number(type="text" pattern="/[0-9]/" v-model="numbers[0]" :class="firstActive" maxLength="1" ref="first" @input="$refs.second.focus()")
                input.number(type="text" pattern="/[0-9]/" v-model="numbers[1]" :class="secondActive" maxLength="1" ref="second" @input="$refs.third.focus()")
                input.number(type="text" pattern="/[0-9]/" v-model="numbers[2]" :class="thirdActive" maxLength="1" ref="third" @input="$refs.fourth.focus()")
                input.number(type="text" pattern="/[0-9]/" v-model="numbers[3]" :class="fourthActive" maxLength="1" ref="fourth")
            .re-verification-resend
                span.resend-title Didn’t receive code?
                span.resend(@click="resend") Resend
            .re-verification-button
                button(@click="submit") submit
</template>
<script>
export default {
    name: "login-2fa",
    props: {
        phone: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            numbers: [],
            error: false,
        }
    },
    computed: {
        validationError() {
            return this.numbers.length < 4
                ||this.numbers[0] === ''
                || this.numbers[1] === ''
                || this.numbers[2] === ''
                || this.numbers[3] === ''
        },
        firstActive() {
            if (this.error) {
                return 'error'
            }
            return {
                'not-empty' : this.numbers[0]
            }
        },
        secondActive() {
            if (this.error) {
                return 'error'
            }
            return {
                'not-empty' : this.numbers[1]
            }
        },
        thirdActive() {
            if (this.error) {
                return 'error'
            }
            return {
                'not-empty' : this.numbers[2]
            }
        },
        fourthActive() {
            if (this.error) {
                return 'error'
            }
            return {
                'not-empty' : this.numbers[3]
            }
        }
    },
    methods: {
        submit() {
            if (this.validationError) {
                return false;
            }

            this.$emit('submit', this.numbers.join(''))
        },

        resend() {
            this.$emit('submit', '')
            this.clearForm()
        },

        clearForm() {
            this.numbers = []

            this.error = false
        },

        showValidationError() {
            this.error = true
        },
    }
}
</script>
